<template>
  <div>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
      <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
        <vx-card>
          <div slot="no-body" class="full-page-bg-color">

            <div class="vx-row no-gutter justify-center items-center">

              <div class="vx-col hidden lg:block lg:w-1/2">
                <img style="max-width: 400px; width: 400px; height: 230px; max-height: 230px" src="@/assets/images/landing_mtn.jpg" alt="login" class="mx-auto">
<!--
                <img style="max-width: 400px; width: 400px; height: 230px; max-height: 230px" src="@/assets/images/landing.jpeg" alt="login" class="mx-auto">
-->
              </div>

              <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                <div class="p-8 login-tabs-container">

                  <div class="vx-card__title mb-4">
                    <h4 class="mb-4">Enter le code de Vérification</h4>
                    <p>Veuillez saisir le code reçu par sms.</p>
                  </div>

                  <div>
                    <vs-input autocomplete="off"
                              @keyup.enter="login()"
                              type="text"
                              :danger="errors_ve.code ? true: false"
                              :danger-text="errors_ve.code ? errors_ve.code[0] : ''"
                              name="password"
                              @keyup="error.danger=false"
                              icon-no-border
                              icon="icon icon-lock"
                              icon-pack="feather"
                              label-placeholder="Code"
                              v-model="password_code"
                              class="w-full mt-6" />




                    <div class="flex flex-wrap justify-between my-5">
                      <b :v-show="true" class="mb-3"></b>
                      <!--<a href="#" @click.stop="loginPhone()">Renvoyer le code</a>-->
                    </div>
                    <vs-button :disabled="verification" class="float-right mb-8" @click="login">Valider</vs-button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <!--<p style="margin-top: -100px" class="flex w-full vx-row items-center justify-center">
      Copyright &copy; Togocel Designed By
      <a target="_blank" style="margin-left: 5px !important;" href="http://ebusinessafrique.com">e-Business Afrique</a>
    </p>-->
    <p style="margin-top: -100px" class="flex w-full vx-row items-center justify-center">
      Copyright &copy; MTN Designed By
      <a target="_blank" style="margin-left: 5px !important; color: black" href="http://ebusinessafrique.com">e-Business Afrique</a>
    </p>
  </div>
</template>

<script>
let base_self;

export default{
  data() {
    return {
      errors_ve: [],
      error: {
        danger: false
      },
      phone: "",
      password: "",
      password_code: "",
      checkbox_remember_me: false,
    }
  },
  computed: {
    verification () {
      return (base_self.password_code.length === 0);
    },
    verificationMessage () {
      return (base_self.password_code.length !== 0) ? "Code incorrect. Veuillez saisir le bon code." : "Le code est requis.";
    }
  },
  methods: {

    login() {
      base_self.$vs.loading()
      var params = { phone: window.LoginCCMT.phone, code: base_self.password_code };
      base_self.$http.post('/login/verify', params).then((response) => {
        if (response.data.status) {
          window.GETCCMT.success('Vérifier avec succès', response);
          response.data.user.displayName = response.data.user.name;
          response.data.user.userRole = response.data.user.profile;
          response.data.user.company = response.data.user.customer;
          response.data.user.photoURL = response.data.user.photo;
          base_self.$store.dispatch('updateUserInfo', response.data.user);
          base_self.errors_ve = []
          base_self.$vs.loading.close()
          base_self.$router.push('/dashboard');
        } else {
          base_self.$vs.loading.close()
          base_self.error.danger = true;
          // window.GETCCMT.error(response.data);
        }
      })
        .catch((error) => {
          base_self.errors_ve = error.response.data.errors
          base_self.error.danger = true;
          base_self.$vs.loading.close()
          console.log('error: ', error);
        });
    },
    loginPhone() {
      base_self.$store.state.ueser_login({ phone: base_self.phone, password: base_self.password })
        .then((response) => {
          if (response.data.status) {
            base_self.password_code = response.data.code;
            base_self.code = response.data.code;
            window.LoginCCMT.code = response.data.code;
            window.GETCCMT.success('Le code est renvoyé avec succès', response);
          } else {
            window.GETCCMT.error(response.data);
          }
        })
        .catch((error) => {
          console.log('error: ', error);
        });
    }
  },
  async created() {
    base_self = this;
    //base_self.password_code = window.LoginCCMT.code;
    base_self.password = window.LoginCCMT.password;
    base_self.phone = window.LoginCCMT.phone;
  }
}
</script>
